import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import {
  brand,
  heroContent,
  whoWeAre,
  productCategories,
  wallOfFame,
  featuredProducts,
  galleryContent,
  galleryItems,
} from "../data/siteData";
import "../styles/Home.css";
import bouquet from "../assets/bouquet.png";
import WallOfFame from "../components/WallOfFame";
import BentoGallerySection from "../components/BentoGallerySection";
import ClientTestimonial from "../components/ClientTestimonial";
import RotatingProductCards from "../components/RotatingProductCards";
// Self-contained page — pulls its own data, no props from App.
export default function Home() {
  return (
    <div className="tp-home">
      {/* ---------------- Hero — infinite rotating orbit ---------------- */}
      <section className="tp-home-hero  tp-floral-bg">
        {/* Decorative dried leaves drifting through the hero — the
            page's one signature motion moment, tying the animation
            back to the material the brand is actually made from. */}
        <div className="tp-home-hero__petals" aria-hidden="true">
          <Icon name="leaf" size={26} className="tp-home-hero__petal tp-home-hero__petal--1" />
          <Icon name="leaf" size={18} className="tp-home-hero__petal tp-home-hero__petal--2" />
          <Icon name="leaf" size={22} className="tp-home-hero__petal tp-home-hero__petal--3" />
          <Icon name="leaf" size={16} className="tp-home-hero__petal tp-home-hero__petal--4" />
        </div>
        <div className="tp-container tp-home-hero__stage">
          {/* <CircularShowcase images={heroShowcaseImages} /> */}

          <div className="tp-home-hero__center">
            <span className="tp-eyebrow">{heroContent.eyebrow}</span>
            <h1 className="tp-home-hero__title">
              {heroContent.title}
              <br />
              {heroContent.titleAccent}
            </h1>
            <p className="tp-home-hero__intro">{heroContent.intro}</p>

            <Link to="/handicrafts" className="tp-home-hero__cta">
              {heroContent.ctaLabel}
              <Icon name="arrow" size={16} />
            </Link>

            <div className="tp-home-hero__stats">
              {heroContent.stats.map((stat, index) => (
                <React.Fragment key={stat.label}>
                  <div className="tp-home-hero__stat">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                  </div>
                  {index < heroContent.stats.length - 1 && (
                    <span className="tp-home-hero__stat-divider" />
                  )}
                </React.Fragment>
              ))}
            </div>
            {/* <div className="tp-home-hero__img">
              <img
                src={feather}
                alt={brand.name}
                className="tp-home-hero__mark"
              />
            </div> */}
          </div>
        </div>
      </section>

      {/* ---------------- Who We Are ---------------- */}
      <section className="tp-section tp-home-who ">
        <div className="tp-container tp-home-who__grid">
          <div className="tp-home-who__text">
            <span className="tp-eyebrow">{whoWeAre.eyebrow}</span>
            <h2 className="tp-section-heading">{whoWeAre.heading}</h2>
            {whoWeAre.paragraphs.map((para) => (
              <p key={para.slice(0, 24)}>{para}</p>
            ))}
            <div className="tp-home-who__badges">
              {whoWeAre.whyItMatters.map((matt) => (
                <span className="tp-badge" key={matt.title}>
                  {/* <Icon name="checkCircle" size={16} /> */}
                  <img className="tp-home-icon" src={matt.svg} alt="good" />
                  {matt.title}
                </span>
              ))}
            </div>
          </div>

          <div className="tp-home-who__media">
            <div className="tp-home-who__photo-wrap">
              <img src={bouquet} alt="Terra Bloom Studio workshop" />
            </div>
            <div className="tp-home-who__callout">
              <strong>{whoWeAre.statCallout.value}</strong>
              <span>{whoWeAre.statCallout.label}</span>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- What We Make — Product Categories ---------------- */}
      {productCategories.map((cat) => (
        <section className="tp-section tp-home-categories" key={cat.id}>
          <div className="tp-container">
            <div className="tp-home-categories__header">
              <div>
                <span className="tp-eyebrow">{cat.eyebrow}</span>
                <span className="tp-home-categories__label">{cat.label}</span>
                <h2 className="tp-section-heading">{cat.heading}</h2>
              </div>
              <p className="tp-home-categories__desc">{cat.description}</p>
            </div>

            <div className="tp-home-categories__grid">
              {cat.groups.map((group) => (
                <Link
                  to="/handicrafts"
                  className="tp-home-categories__card"
                  key={group.title}
                >
                  <div className="tp-home-categories__photo-wrap">
                    <img src={group.image} alt={group.title} loading="lazy" />
                  </div>
                  <h4>{group.title}</h4>
                  {/* <span>
                    {group.styleCount} STYLE
                    <Icon name="arrow" size={14} />
                  </span> */}
                </Link>
              ))}
            </div>

            <Link to="/handicrafts" className="tp-testimonial__link">
              {cat.seeAllLabel}
              <Icon name="arrow" size={15} />
            </Link>
          </div>
        </section>
      ))}

      {/* ---------------- Gallery ---------------- */}
      <BentoGallerySection
        id="gallery"
        items={galleryItems}
        eyebrow={galleryContent.eyebrow}
        heading={galleryContent.heading}
        sub={galleryContent.sub}
        seeAllLabel={galleryContent.seeAllLabel}
        seeAllPath="/gallery"
      />

      {/* ---------------- Wall of Fame ---------------- */}
      {/* ---------------- Wall of Fame / Mobile Product Carousel ---------------- */}
      <section className="tp-wof">
        <div className="tp-wof__container">
          {/* Header */}
          <div className="tp-wof__header">
            <span className="tp-wof__eyebrow">{wallOfFame.eyebrow}</span>

            <p className="tp-wof__sub">{wallOfFame.sub}</p>
          </div>
          <div className="tp-home-wall-of-fame">
            <div className="tp-home-wall-of-fame__desktop">
              <WallOfFame
                eyebrow={wallOfFame.eyebrow}
                sub={wallOfFame.sub}
                images={wallOfFame.images}
              />
            </div>

            <div className="tp-home-wall-of-fame__mobile">
              <RotatingProductCards
                items={featuredProducts}
                autoRotate={true}
                intervalMs={3200}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- Testimonials ---------------- */}
      {/* <section className="tp-section tp-home-testimonials" id="testimonials">
        <div className="tp-container">
          <div className="tp-home-testimonials__header">
            <div>
              <span className="tp-eyebrow">{testimonials.eyebrow}</span>
              <h2 className="tp-section-heading">{testimonials.heading}</h2>
            </div>
            <p>{testimonials.sub}</p>
          </div>

          <div className="tp-home-testimonials__track">
            {testimonials.items.map((item) => (
              <div className="tp-home-testimonials__card" key={item.name}>
                <span className="tp-home-testimonials__quote-mark">"</span>
                <p>{item.quote}</p>
                <strong>{item.name}</strong>
                <span className="tp-home-testimonials__location">
                  {item.location}
                </span>
                <span className="tp-home-testimonials__stars">
                  {"★".repeat(item.rating)}
                  {"☆".repeat(5 - item.rating)}
                </span>
              </div>
            ))}
          </div>

          <Link
            to="/our-story"
            className="tp-home-categories__see-all"
            style={{ margin: "28px auto 0" }}
          >
            {testimonials.seeAllLabel}
            <Icon name="arrow" size={15} />
          </Link>
        </div>
      </section> */}
      <ClientTestimonial />

      {/* ---------------- Closing CTA ---------------- */}
      <section className="tp-home-cta">
        <div className="tp-container tp-home-cta__inner">
          <div>
            <h2>Ready to bring {brand.name} into your product line?</h2>
            <p>
              Tell us what you're building — pricing, samples, and bulk orders,
              all in one conversation.
            </p>
          </div>
          <Link to="/request-quote" className="tp-btn tp-btn--primary">
            Request a Quote
            <Icon name="arrow" size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
